module.exports = __webpack_public_path__ + "img/02030211.11ce699e.svg";